import "./uploadData.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { doGet } from "../../../../utils/request";
import React, { useState, useEffect } from "react";
import HistroyTable from "./UploadDataHistoryTable";
import PopupModal from "../../../../Components/PopupModal";
import { addDistrict } from "../../../../actionCreators/Zones";
import { getDistricts } from "../../../../actionCreators/DropDown";
import * as propertyActions from "../../../../actionCreators/Property";
import { UploadOutlined, ClockCircleOutlined,PlusOutlined } from "@ant-design/icons";
import { message, Upload, Typography, Card, Col, Row, Select,Button ,Input} from "antd";
import InputLabel from "../../../../Components/FloatingSelectLabel/FloatingSelectLabel";


const { Option } = Select;
const { Dragger } = Upload;

function UploadData({
  user,
  districts,
  latestFile,
  addDistrict,
  getDistricts,
  districtValue,
  getLatestDataFile,
  getUploadLookupData,
}) {
  useEffect(() => {
    getDistricts();
    getLatestDataFile({ district_id: isDistrictAdmin && adminDistrictId ? adminDistrictId : null });
  }, []);
  useEffect(() => {
    if (latestFile.data) {
      setLatestFileData(latestFile.data[0]);
    }
  }, [latestFile]);
  const [district, setDistrict] = useState(null);
  const [districtError, setDistrictError] = useState(false);
  const [latestFileData, setLatestFileData] = useState(null);
  const [districtSelectActive, setDistrictSelectActive] = useState(false);
  const [showDistrictModal, setShowDistrictModal] = useState(false);
  const [nameError,setNameError]=useState('success')
  const [codeError,setCodeError]=useState('success')
  const [btnloading,setBtnLoading]=useState(false)
  const [name,setName]=useState(null)
  const [code,setCode]=useState(null)
  const [showWarning,setShowWaring]=useState(false)
  const [errorMessage,setErrorMessage]=useState(null)
  const [isDistrictAdmin] = React.useState(user?.currentUser?.data?.user_roles.findIndex((e) => e.role_id === 5) >=
  0 ? true : false);
  const [adminDistrictId] = React.useState(user?.currentUser?.data?.district?.id);


  useEffect(()=>{
    if(districtValue.data && !districtValue.error)
    { 
      setBtnLoading(districtValue.loading)
      setShowDistrictModal(false);
      setShowWaring(false)
      setName(null);
      setCode(null)
      getDistricts();

    }
    if(districtValue.error)
    {
      setBtnLoading(districtValue.loading)
      setErrorMessage(districtValue?.error)
      setShowWaring(true)
    }
  },[districtValue])
  const props = {
    multiple: false,
    accept: ".csv",
    maxCount: 1,
    data: { district: district },
    action: district && process.env.REACT_APP_API_URL + "/dataTable/upload",
    headers: {
      "access-token": JSON.parse(localStorage.getItem("access-token")),
    },
    onChange(info) {
      if (district) {
        const { status } = info.file;
        if (status !== "uploading") {
        }
        if (status === "done") {
          message.success(`${info.file.name} file uploaded successfully.`);
          getDistricts();
          getLatestDataFile({ district_id: isDistrictAdmin && adminDistrictId ? adminDistrictId : null });
          getUploadLookupData({ page: 0, pageSize: 10 });
        } else if (status === "error") {
          message.error(`${info.file.name} file upload failed.`);
        }
      } else {
        setDistrictError(true);
      }
    },
  };
  const downloadErrorReport = async () => {
    let fileDetails = await doGet(
      "/dataTable/error-report?parent_id=" + latestFileData.id
    );
    if (fileDetails.data.filename) {
      window.location =
        process.env.REACT_APP_SNG_STORAGE_SERVER_URL +
        "uploads/" +
        fileDetails.data.filename;
    } else {
      message.error("Download failed.");
    }
  };
  const handAddDistrict=()=>{
    if(name && code)
    {
      addDistrict({name:name,code:code})
      setBtnLoading(true)
    }
    else{
      if(!name)
      {
        setNameError('error')
      }
      if(!code)
      {
        setCodeError('error')
      }
    }
    
  }

  return (
    <div className="main-container">
      <Row>
        <Col className="header" span={24}>
          <Typography className="heading">
            <span> Upload Data</span>
          </Typography>
          { !isDistrictAdmin && <Button
            className="export-report-button"
            type="primary"
            // size={"large"}
            icon={<PlusOutlined />}
            onClick={()=>{setShowDistrictModal(true)}}
          >
            <span className="download-error-button-text">
              ADD DISTRICT
            </span>
          </Button> }
        </Col>
      </Row>
      <Row className="data-upload-container" gutter={[8, 8]}>
        <Col span={18}>
          <Card bordered={false} className="upload-data-card">
            <div className="data-upload-header">Upload Data</div>
            <div className="data-upload-helper-text">
              <span className="link">
                <a
                  href="https://docs.google.com/spreadsheets/d/1IWuJWB1b2M0GBIxavEWMcoahFHbz3fxEoG78u8aMD9A/edit?usp=sharing"
                  target={"_blank"}
                >
                  Click here{" "}
                </a>
              </span>
              to view the acceptable CSV format.
            </div>
            <div
              onFocus={() => {
                setDistrictSelectActive(true);
              }}
              onBlur={() => {
                setDistrictSelectActive(false);
              }}
              className="dropdowns"
            >
              <InputLabel
                value={district}
                labelText="District"
                active={districtSelectActive}
              >
                <Select
                  size="large"
                  onChange={(event) => {
                    setDistrict(event);
                    setDistrictError(false);
                  }}
                  status={districtError ? "error" : "success"}
                  value={district}
                  loading={districts?.data ? false : true}
                  allowClear
                >
                  {districts?.data &&
                    districts?.data.map((value) => {
                      return (
                        <Option value={value.id} key={value.id}>
                          {value.name}
                        </Option>
                      );
                    })}
                </Select>
              </InputLabel>
            </div>
            <Dragger {...props} className="upload-data-dragger">
              <p className="upload-drag-icon">
                <UploadOutlined />
              </p>
              <p className="ant-upload-text">
                Drag & Drop or Click to Upload File here
              </p>
              <p className="ant-upload-hint">Only CSV files are supported</p>
            </Dragger>
          </Card>
        </Col>
        <Col span={6}>
          <Card bordered={false} className="last-uploaded-card">
            <div className="clock-icon-container">
              <ClockCircleOutlined className="clock-icon" />
            </div>

            <div className="last-upload-deatails-container">
              {latestFileData ? (
                <div>
                  <div className="last-upload-message">
                    Last file was uploaded at{" "}
                    {new Date(latestFileData?.created_at).toLocaleString()}
                  </div>
                  <div className="last-upload-status">
                    <span className="status-header">Status : </span>
                    <span
                      className={`status-data ${
                        latestFileData.status === "COMPLETED"
                          ? "complete-status-color"
                          : latestFileData.status === "PROCESSING"
                          ? "waiting-status-color"
                          : "error-status-color"
                      }`}
                    >
                      {" "}
                      {latestFileData.status}
                    </span>
                  </div>

                  {latestFileData.status === "ERROR" && (
                    <>
                      <div className="last-upload-status">
                        <span className="status-header">Note : </span>
                        <span className="status-data">
                          {" "}
                          {latestFileData.notes}
                        </span>
                      </div>
                      <div
                        className="download-error-button"
                        onClick={downloadErrorReport}
                      >
                        <span className="download-error-button-text">
                          DOWNLOAD ERROR REPORT
                        </span>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div
                  classname="error-message-data"
                  style={{ marginTop: "50px" }}
                >
                  No Data Uploaded Yet.
                </div>
              )}
            </div>
          </Card>
        </Col>
      </Row>
      <Row className="history-table-container">
        <Col span={24}>
          <HistroyTable />
        </Col>
      </Row>
      <PopupModal
            title={"Add District Details"}
            centered
            visible={showDistrictModal}
            onCancel={() => 
              {
                setShowDistrictModal(false)
                setNameError('success')
                setCodeError('success')
              }
            }
            footer={[
              <Button
                key="cancel"
                type="link"
                onClick={() => {
                  setShowDistrictModal(false);
                  setNameError('success')
                  setCodeError('success')
                }}
                style={{color:'red'}}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                type="link"
                disabled={name&&code?false:true}
                onClick={handAddDistrict}
                loading={btnloading}
                >
              Save
            </Button>
            ]}
          >
            <InputLabel
              value={name}
              labelText="Name"
              active={name?true:false}
            >
                <Input className="input-lookup-data" status={nameError} value={name}  onChange={(e)=>{setName(e.target.value)}}/>
            </InputLabel>
            <br/>
            <InputLabel
              value={code}
              labelText="Code"
              active={code?true:false}
            >
                <Input className="input-lookup-data" status={codeError} value={code}  onChange={(e)=>{setCode(e.target.value)}}/>
            </InputLabel>
      </PopupModal>
      <PopupModal
        title={"Warning"}
        centered
        visible={showWarning}
        onCancel={() => {setShowWaring(false)}}
        footer={[
          <Button
            key="cancel"
            type="link"
            onClick={() => {
              setShowWaring(false);
            }}
          >
            ok
          </Button>
        ]}
      >
        {errorMessage}
      </PopupModal>
    </div>
  );
}

const mapStateToProps = ({
  user: user,
  dropDown: { districts },
  property: { latestFile },
  zones: {districtValue}
}) => ({
  user,
  districts,
  latestFile,
  districtValue,
});

const mapDispatchToProps = (dispatch) => ({
  getDistricts: bindActionCreators(getDistricts, dispatch),
  getLatestDataFile: bindActionCreators(
    propertyActions.getLatestDataFile,
    dispatch
  ),
  getUploadLookupData: bindActionCreators(
    propertyActions.getUploadLookupData,
    dispatch
  ),
  addDistrict: bindActionCreators(
    addDistrict,
    dispatch
  ),
});
UploadData.propTypes = {
  getDistricts: PropTypes.func.isRequired,
  getLatestDataFile: PropTypes.func.isRequired,
  getUploadLookupData: PropTypes.func.isRequired,
  addDistrict: PropTypes.func.isRequired,

};

export default connect(mapStateToProps, mapDispatchToProps)(UploadData);
